export var DeepLink;
(function (DeepLink) {
    DeepLink["BOOKINGS_OFFERINGS"] = "scheduler/owner/offerings";
    DeepLink["BOOKINGS_FORM"] = "scheduler/owner/bookings-form-settings";
    DeepLink["BOOKINGS_INDIVIDUAL_FORM"] = "scheduler/owner/offerings-form/new/INDIVIDUAL";
    DeepLink["BOOKINGS_GROUP_FORM"] = "scheduler/owner/offerings-form/new/GROUP";
    DeepLink["BOOKINGS_WIZARD"] = "scheduler/owner/offerings/wizard";
})(DeepLink || (DeepLink = {}));
//# sourceMappingURL=DeepLink.js.map